export default __webpack_public_path__ + "src/assets/slack.fde12719c8fe7c790febaa63895070f2.svg";